import React from 'react';
import './css/intro.css';
export default function Intro() {
  return (
    <div className="container" id="intro">
      <div className="container-fluid intro-full">
        <div className="intro row">
          <div className="col-md-5 ">
            <img
              src="assets/Tomal_6.png"
              alt="pic"
              style={{ height: 'auto', width: '100%' }}
            />
          </div>

          <div className="small-intro col-md-5 p-3">
            <div>
              <h4 className="intro-head">
                Hi, I'm <span className="intro-name">Raihanul Islam Tomal</span>
              </h4>
              <h5 className="intro-head">Softwer Developer</h5>

              <p className="intro-peragraph">
                I always attempt to learn those things which are essential. I
                love to do teamwork. I have participated in many group projects
                during varsity life & the experience is mention worthy.
              </p>

              <div className="d-flex">
                <button className="btn btn-primary m-1">
                  <a
                    className="intro-button"
                    href="assets/JOB_CV_Raihanul.pdf"
                    download
                  >
                    <i class="bi bi-download"></i> Download CV
                  </a>
                </button>
                <button className="btn btn-primary m-1">
                  <a className="intro-button" href="#contact">
                    Contact Me <i className="bi bi-arrow-down-circle-fill"></i>
                  </a>
                </button>
              </div>
            </div>
          </div>
          <div className="social-icon col-md-2 ">
            <div className="row ">
              <a
                href="https://github.com/Raihanultomal"
                rel="noreferrer"
                target="_blank"
                className="intro-icon-decoration"
              >
                <i className="bi bi-github"></i>
              </a>
            </div>
            <div className="row">
              <a
                href="https://www.linkedin.com/in/md-raihanul-islam-tomal-a96179228/"
                rel="noreferrer"
                target="_blank"
                className="intro-icon-decoration"
              >
                <i className="bi bi-linkedin"></i>
              </a>
            </div>
            <div className="row">
              <a
                href="https://api.whatsapp.com/send?phone=+8801521401218"
                rel="noreferrer"
                target="_blank"
                className="intro-icon-decoration"
              >
                <i className="bi bi-whatsapp"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
